/**
 * Boot "Sign in" escape hatch timing. A stored session means the user is already
 * signed in and the background service is still adopting auth — don't ask them to
 * sign in until that has had a bounded chance to finish (still before the 15s deadline).
 */
import { BOOT_ESCAPE_HATCH_MS } from './bootDeadline';
import { isValidRefreshToken } from './authTokens';
import { diagnosticLog } from '../utils/diagnosticLogger';

export const BOOT_ESCAPE_HATCH_WITH_SESSION_MS = 12_000;

export function hasStoredSession(): boolean {
  try {
    const raw = localStorage.getItem('maestro_auth');
    const rec = raw ? JSON.parse(raw) : null;
    return !!rec?.accessToken && isValidRefreshToken(rec?.refreshToken);
  } catch {
    return false;
  }
}

export function resolveBootEscapeHatchMs(): number {
  return hasStoredSession() ? BOOT_ESCAPE_HATCH_WITH_SESSION_MS : BOOT_ESCAPE_HATCH_MS;
}

/** Schedule the escape hatch; returns a cleanup that cancels it. */
export function scheduleBootEscapeHatch(show: () => void): () => void {
  const delayMs = resolveBootEscapeHatchMs();
  if (delayMs !== BOOT_ESCAPE_HATCH_MS) {
    try {
      diagnosticLog('info', 'other', 'boot_signin_escape_deferred', { delay_ms: delayMs });
    } catch { /* diagnostic only */ }
  }
  const timer = setTimeout(show, delayMs);
  return () => clearTimeout(timer);
}
